import { useMemo } from "react";
import RffFieldsRenderer from "../../../components/finalForm/shared/RffFieldsRenderer";
import RffGroup from "../../../components/finalForm/shared/RffGroup";
import { loanQuickAppFormKeys as FMK } from "../../../constants/models/forms/loanQuickAppFormKeys";
import { selectOptionsEstimatedFico } from "../../../constants/selectOptions/selectOptionsEstimatedFico";
import ProductDescription from "../components/ProductDescription";

const BMK = FMK.borrowers[0];
const fieldName = "borrowers[0]"; // For future multi-property support
const LoanQuickAppStepThreeInvestorProfile = () => {
  const fields = useMemo(
    () => [
      {
        name: `${fieldName}.${BMK.similar_projects_last_3_years}`,
        label:
          "How many similar investment projects have you completed in the past 36 months?",
        type: "number",
        required: true,
      },
      {
        name: `${fieldName}.${BMK.cashLiquidity}`,
        label: "Cash reserves",
        type: "dollar",
        required: true,
      },
      {
        name: `${fieldName}.${BMK.estimatedFICO}`,
        label: "Approximate Credit Score?",
        type: "selectToggle",
        options: selectOptionsEstimatedFico,
        required: true,
      },
      {
        name: `${fieldName}.${BMK.smsOptIn}`,
        label: "May we text you about your loan?",
        type: "booleanToggle",
      },
      {
        name: `${fieldName}.${BMK.referralSource}`,
        label: "Did anyone refer you?",
        type: "text",
      },
      {
        name: `${fieldName}.${BMK.additionalLoanDetails}`,
        label:
          "Any additional details or items that you might be pertinent to the loan?",
        type: "textarea",
        // rows: 3,
        minHeight: 80,
      },
    ],
    []
  );

  const investorInformationfields = useMemo(
    () => [
      {
        size: 6,
        name: `${fieldName}.${BMK.firstName}`,
        label: "First name",
        type: "text",
        required: true,
      },
      {
        size: 6,
        name: `${fieldName}.${BMK.lastName}`,
        label: "Last name",
        type: "text",
        required: true,
      },
      {
        name: `${fieldName}.${BMK.phone}`,
        label: "Phone number",
        type: "phone",
      },
      {
        name: `${fieldName}.${BMK.emailAddress}`,
        label: "Email",
        type: "email",
        required: true,
      },
      { name: `${fieldName}.${BMK.company}`, label: "Company", type: "text" },
    ],
    []
  );
  return (
    <>
      <RffGroup title="Investor Profile" sx={{ position: "relative" }}>
        <ProductDescription />
        <RffFieldsRenderer fields={fields} />
      </RffGroup>
      <RffGroup title="Investor Information">
        <RffFieldsRenderer fields={investorInformationfields} />
      </RffGroup>
    </>
  );
};

export default LoanQuickAppStepThreeInvestorProfile;
